// extracted by mini-css-extract-plugin
var _1 = "BaseUpsellModal-module__contents___x2G0Y";
var _2 = "BaseUpsellModal-module__heading___rjUq0";
var _3 = "BaseUpsellModal-module__logo___GMfyD";
export { _1 as "contents", _2 as "heading", _3 as "logo" }
